import axios from 'axios';
import config from '../config.json';
import { formatDisplayTS } from '../components/common/Utilities';

import {
  SET_PLAYBACK_DATE,
  SET_PLAYBACK_CAMERA,
  SET_PLAYBACK_TAGS,
  SET_PLAYBACK_STARTTIME,
  SET_PLAYBACK_ENDTIME,
  GET_PLAYBACK_EVENTS_START,
  GET_PLAYBACK_EVENTS_SUCCESS,
  GET_PLAYBACK_EVENTS_FAIL,
  SET_FILTERED_EVENTS,
  SET_PLAYBACK_SCROLLER_OBJ,
  SET_SELECTED_EVENT,
  SET_EVENT_CACHE,
  FLAG_EVENT_FOR_EXPORT,
  SET_SELECTED_VIDEO_PLAYING,
  SET_SELECTED_VIDEO_PLAYING_URL,
  GET_EVENT_SUCCESS,
  GET_BANDWIDTH_USAGE_SUCCESS,
} from './types';

const API_URL = process.env.REACT_APP_BACKEND || config.backend;

export const setDate = (date) => {
  return {
    type: SET_PLAYBACK_DATE,
    payload: date
  }
}

export const setCamera = (camId) => {
  return {
    type: SET_PLAYBACK_CAMERA,
    payload: camId
  }
}

export const setEventTags = (eventTags, filter, add) => {
  let currentTags = eventTags ? [...eventTags] : []
  let index = currentTags.indexOf(filter)

  if (add && index === -1) {
    currentTags.push(filter)
  } else if (!add) {
    currentTags.splice(index, 1)
  }

  return {
    type: SET_PLAYBACK_TAGS,
    payload: currentTags
  }
}

export const setStartTime = (time) => {
  return {
    type: SET_PLAYBACK_STARTTIME,
    payload: time
  }
}

export const setEndTime = (time) => {
  return {
    type: SET_PLAYBACK_ENDTIME,
    payload: time
  }
}

export const getPlaybackEvents = (token, date, cameras, camera, eventTags, startTime, endTime, events, newSearch) => {
  return async ( dispatch ) => {
    const selectedCam = cameras.find(c => c.bID.toString() === camera)
    const deviceId = selectedCam.sDeviceID
    const cam = selectedCam.bCamera
    const formattedDate = date.split('-').join('') //2022-11-07 to 20221107

    dispatch({
      type: GET_PLAYBACK_EVENTS_START,
      searchFilters: {date, camera, eventTags, startTime, endTime},
      newSearch: newSearch,
    })

    await axios({
      method: 'get',
      url: `${API_URL}ve/playbackevents?device=${deviceId}&cam=${cam}&date=${formattedDate}&startTime=${startTime}&endTime=${endTime}`,
      headers: {
        'Authorization': 'Bearer ' + token
      }

    }).then((response) => {
      if (!response.data) {
        throw new Error('bad response from get playback events.')
      }

      // events will contain all events that falls in the searched date and camera
      // filterdEvents will contain only those that matches the tags
      let newEvents = [...(newSearch ? [] : events), ...response.data]
      let newFilteredEvents = [...newEvents]

      for (let i = 0; i < eventTags.length; i++) {
        newFilteredEvents = newFilteredEvents.filter(ev => ev.sTags.split(',').includes(eventTags[i]))
      }

      dispatch({
        type: GET_PLAYBACK_EVENTS_SUCCESS,
        events: newEvents,
        filteredEvents: newFilteredEvents,
      })

    }).catch( error => {
      console.log(error)
      dispatch({type: GET_PLAYBACK_EVENTS_FAIL})
    })
  }
}

export const filterEventsByTags = (events, eventTags, filters) => {
  return async (dispatch) => {
    let filteredEvents = [...events]
    let searchFilters = {...filters}
    searchFilters.eventTags = eventTags

    for (let i = 0; i < eventTags.length; i++) {
      filteredEvents = filteredEvents.filter(ev => ev.sTags.split(',').includes(eventTags[i]))
    }

    dispatch({
      type: SET_FILTERED_EVENTS,
      searchFilters: searchFilters,
      filteredEvents: filteredEvents,
    })
  }
}

export const setScrollerObj = (scroller) => {
  return {
    type: SET_PLAYBACK_SCROLLER_OBJ,
    payload: scroller,
  }
}

export const setSelectedEvent = (event) => {
  return {
    type: SET_SELECTED_EVENT,
    payload: event,
  }
}

export const setEventCache = (events, filteredEvents, eventId) => {
  return async (dispatch) => {
    let evs = [...events]
    const idx1 = evs.findIndex(e => e.bID === eventId)
    evs[idx1].fCached = 1

    let filteredEvs = [...filteredEvents]
    const idx2 = filteredEvs.findIndex(e => e.bID === eventId)
    filteredEvs[idx2].fCached = 1

    dispatch({
      type: SET_EVENT_CACHE,
      events: evs,
      filteredEvents: filteredEvs,
    })
  }
}

export const flagEventForExport = (token, deviceId, eventId, flagged, events, filteredEvents) => {
  return async (dispatch) => {
    // update states first so visually the check/uncheck does not show any delay
    let evs = [...events]
    const idx1 = evs.findIndex(e => e.bID === eventId)
    evs[idx1].fFlagged = flagged

    let filteredEvs = [...filteredEvents]
    const idx2 = filteredEvs.findIndex(e => e.bID === eventId)
    filteredEvs[idx2].fFlagged = flagged

    dispatch({
      type: FLAG_EVENT_FOR_EXPORT,
      events: evs,
      filteredEvents: filteredEvs,
    })

    // then update the database
    await axios({
      method: 'post',
      url: `${API_URL}ve/flagevent?device=${deviceId}&id=${eventId}&flagged=${flagged}`,
      headers: {
        'Authorization': 'Bearer ' + token
      }
    }).then((response) => {
      // states already updated
    }).catch( error => {
      console.log(error)
    })
  }
}

export const setSelectedVideoPlaying = (event) => {
  return {
    type: SET_SELECTED_VIDEO_PLAYING,
    payload: event
  }
}

export const setSelectedVideoPlayingUrl = (url) => {
  return {
    type: SET_SELECTED_VIDEO_PLAYING_URL,
    payload: url
  }
}

// not actively used function
export const getEvents = (deviceIdList, devices, popupMessages, token, existingEvents, view, camera, date, cameras) => {
  // this is to get device events periodically
  // it was previously shown as popup message - see commits before live view ui rework #86aytattn for working implementation
  // keeping this just in case we'll use it later

  let eventsToAdd = existingEvents;
  let d = devices;
  let popups = popupMessages &&  popupMessages.length > 0 ? popupMessages : [];

  const makeId = () => {
    return '_' + Math.random().toString(36).substr(2, 9);
  };

  return async ( dispatch ) => {
    await  axios({
      method: 'post',
      url: API_URL + `ve/events?device=${deviceIdList[0]}`,
      headers: {
        'Authorization': 'Bearer ' + token
      },
      data: devices
    })
    .then((response) => {
      if(!response.data || !response.data.result){
        throw new Error('bad response from get event list.')
      };

      let events = response.data.result;

      for(let i=0;i<events.length;i++) {
        let e = events[i];
        // update device.sLastEventTS
        let targetDevice = d.find( d => d.sDeviceID === e.sDeviceID);
        targetDevice.sLastEventTS = e.sLastEventTS;

        // parse out the events we want and add popups if necessary
        let eventArr = e.events;
        for(let ix=0; ix<eventArr.length;ix++){
          let ev = eventArr[ix];
          let type = ev.sType;
          switch(type) {
            case "DEVICE_OFFLINE":
              popups.unshift({ id: makeId(), color: '#ff726f', message: `device offline: ${ev.sDeviceID}`, timestamp: formatDisplayTS(ev.sTimeStamp, false) });
              // find the device and set fOnline = 0
              break;
            case "DEVICE_ONLINE":
              popups.unshift({ id: makeId(), color: '#8FBC8F', message: `device online: ${ev.sDeviceID}`, timestamp: formatDisplayTS(ev.sTimeStamp, false) });
              // find the device and set fOnline = 1
              break;
            case "CAMERA_OFFLINE":
              // need to check if camera.fEnabled
              // been getting fOnline === 1 && fEnabled === 0, which seems strange
              popups.unshift({ id: makeId(), color: '#ff726f', message: `camera offline: device ${ev.sDeviceID} : cam ${ev.bCamera}`, timestamp: formatDisplayTS(ev.sTimeStamp, false) });
              // find the device and set fOnline = 0
              break;
            case "CAMERA_RESTORED":
              // need to check if camera.fEnabled
              // been getting fOnline === 1 && fEnabled === 0, which seems strange
              popups.unshift({ id: makeId(), color: '#8FBC8F', message: `camera restored: device ${ev.sDeviceID} : cam ${ev.bCamera}`, timestamp: formatDisplayTS(ev.sTimeStamp, false) });
              // find the device and set fOnline = 1
              break;
              // temp case
            //  case "VIDEO":
            //   popups.unshift({ id: makeId(), color: 'lightblue', message: `video event: device ${ev.sDeviceID} : cam ${ev.bCamera}`, timestamp: formatDisplayTS(ev.sTimeStamp, false) });
            //   // find the device and set fOnline = 1
            //   // if the current view is 'playback', compare the date to our selected playbcak date and our camera to the selected playback camera
            //   let camArr = cameras.filter(c => c.sDeviceID === ev.sDeviceID).filter(c => c.bCamera === ev.bCamera);
            //   let camMatch = false;
            //   if(camArr && camArr.length > 0){
            //     if( camArr.find(c => c.bID === parseInt(camera)) ){
            //       camMatch = true
            //     };
            //   };
            //   if(view === 'playback' && ev.sTimeStamp.substring(0,8) === date.split('-').join('') && camMatch){
            //     eventsToAdd.push(ev);
            //   };
            //   break
            default:
              console.log(`we don't care about this event type right now. ${type}`)
          }
        };
      };

      dispatch({
        type: GET_EVENT_SUCCESS,
        devices: d,
        popupMessages: popups,
        events: eventsToAdd
      });
    })
    .catch( error => {
        console.log(error);
    });
  };
};

// not actively used function
export const getBandwidthUsage = (deviceIdList, devices, token) => {
  // this is to get device usage to compare with the sites data plan
  // keeping this as this might later be used in admin page

  return async ( dispatch ) => {
      await  axios({
        method: 'get',
        url: API_URL + `ve/bandwidthusage?device=${deviceIdList[0]}&ids=${deviceIdList.join(':')}`,
        headers: {
          'Authorization': 'Bearer ' + token
        }
      })
      .then((response) => {
        if(!response.data || !response.data.result){
          throw new Error('bad response from get device status.')
        };
        // example result:
        // [
        //   {
        //     bDataPlanGB: 10
        //     bDataUsage: 8981007
        //     sDeviceID: "0242AC170004"
        //   }
        // ]
        let result = response.data.result;
        let ds = devices;
        for(let i=0;i<result.length;i++){
          let item = result[i];
          let targetD = ds.find(device => device.sDeviceID === item.sDeviceID);
          targetD.bDataUsage = item.bDataUsage;
        };

        dispatch({
          type: GET_BANDWIDTH_USAGE_SUCCESS,
          payload: ds
        });
      })
      .catch( error => {
          console.log(error);
          console.log('GET_BANDWIDTH_USAGE: FAILED')
      });
    };
};

